import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "h-full"
};
const _hoisted_2 = {
  class: "conversation-list"
};
const _hoisted_3 = {
  key: 0,
  class: "conversation-item classify-title"
};
const _hoisted_4 = ["onClick", "onMouseover"];
const _hoisted_5 = {
  class: "title-wrapper"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "button-wrapper"
};
const _hoisted_8 = {
  class: "tool-box"
};
import { ChatConversationApi } from '@/api/ai/chat/conversation';
import RoleRepository from '../role/RoleRepository.vue';
import { Bottom, Top } from '@element-plus/icons-vue';
import { onMounted, ref, toRefs, watch } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
import { ElMessage, ElMessageBox } from 'element-plus';
import Icon from '@/components/Icon/src/Icon.vue';
/** 按照 creteTime 创建时间，进行分组 */
export default /*@__PURE__*/_defineComponent({
  __name: 'ConversationList',
  props: {
    activeId: {
      type: String || null,
      required: true
    }
  },
  emits: ['onConversationCreate', 'onConversationClick', 'onConversationClear', 'onConversationDelete'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const message = useMessage(); // 消息弹窗
    const searchName = ref(''); // 对话搜索
    const activeConversationId = ref(null); // 选中的对话，默认为 null
    const hoverConversationId = ref(null); // 悬浮上去的对话
    const conversationList = ref([]); // 对话列表
    const conversationMap = ref({}); // 对话分组 (置顶、今天、三天前、一星期前、一个月前)
    const loading = ref(false); // 加载中
    const loadingTime = ref(); // 加载中定时器
    // 定义组件 props
    const props = __props;
    // 定义钩子
    const emits = __emit;
    /** 搜索对话 */
    const searchConversation = async e => {
      // 恢复数据
      if (!searchName.value.trim().length) {
        conversationMap.value = await getConversationGroupByCreateTime(conversationList.value);
      } else {
        // 过滤
        const filterValues = conversationList.value.filter(item => {
          return item.title.includes(searchName.value.trim());
        });
        conversationMap.value = await getConversationGroupByCreateTime(filterValues);
      }
    };
    /** 点击对话 */
    const handleConversationClick = async id => {
      // 过滤出选中的对话
      const filterConversation = conversationList.value.filter(item => {
        return item.id === id;
      });
      // 回调 onConversationClick
      // noinspection JSVoidFunctionReturnValueUsed
      const success = emits('onConversationClick', filterConversation[0]);
      // 切换对话
      if (success) {
        activeConversationId.value = id;
      }
    };
    /** 获取对话列表 */
    const getChatConversationList = async () => {
      try {
        // 加载中
        loadingTime.value = setTimeout(() => {
          loading.value = true;
        }, 50);
        // 1.1 获取 对话数据
        conversationList.value = await ChatConversationApi.getChatConversationMyList();
        // 1.2 排序
        conversationList.value.sort((a, b) => {
          return b.createTime - a.createTime;
        });
        // 1.3 没有任何对话情况
        if (conversationList.value.length === 0) {
          activeConversationId.value = null;
          conversationMap.value = {};
          return;
        }
        // 2. 对话根据时间分组(置顶、今天、一天前、三天前、七天前、30 天前)
        conversationMap.value = await getConversationGroupByCreateTime(conversationList.value);
      } finally {
        // 清理定时器
        if (loadingTime.value) {
          clearTimeout(loadingTime.value);
        }
        // 加载完成
        loading.value = false;
      }
    };
    // 定义分组结构的类型
    const getConversationGroupByCreateTime = async list => {
      // 排序、指定、时间分组(今天、一天前、三天前、七天前、30天前)
      // noinspection NonAsciiCharacters
      // 初始化分组映射并指定类型
      const groupMap = {
        置顶: [],
        今天: [],
        一天前: [],
        三天前: [],
        七天前: [],
        三十天前: []
      };
      // 当前时间的时间戳
      const now = Date.now();
      // 定义时间间隔常量（单位：毫秒）
      const oneDay = 24 * 60 * 60 * 1000;
      const threeDays = 3 * oneDay;
      const sevenDays = 7 * oneDay;
      const thirtyDays = 30 * oneDay;
      for (const conversation of list) {
        // 置顶
        if (conversation.pinned) {
          groupMap['置顶'].push(conversation);
          continue;
        }
        // 计算时间差（单位：毫秒）
        const diff = now - conversation.createTime;
        // 根据时间间隔判断
        if (diff < oneDay) {
          groupMap['今天'].push(conversation);
        } else if (diff < threeDays) {
          groupMap['一天前'].push(conversation);
        } else if (diff < sevenDays) {
          groupMap['三天前'].push(conversation);
        } else if (diff < thirtyDays) {
          groupMap['七天前'].push(conversation);
        } else {
          groupMap['三十天前'].push(conversation);
        }
      }
      return groupMap;
    };
    /** 新建对话 */
    const createConversation = async () => {
      // 1. 新建对话
      const conversationId = await ChatConversationApi.createChatConversationMy({});
      // 2. 获取对话内容
      await getChatConversationList();
      // 3. 选中对话
      await handleConversationClick(conversationId);
      // 4. 回调
      emits('onConversationCreate');
    };
    /** 修改对话的标题 */
    const updateConversationTitle = async conversation => {
      // 1. 二次确认
      const {
        value
      } = await ElMessageBox.prompt('修改标题', {
        inputPattern: /^[\s\S]*.*\S[\s\S]*$/,
        // 判断非空，且非空格
        inputErrorMessage: '标题不能为空',
        inputValue: conversation.title
      });
      // 2. 发起修改
      await ChatConversationApi.updateChatConversationMy({
        id: conversation.id,
        title: value
      });
      message.success('重命名成功');
      // 3. 刷新列表
      await getChatConversationList();
      // 4. 过滤当前切换的
      const filterConversationList = conversationList.value.filter(item => {
        return item.id === conversation.id;
      });
      if (filterConversationList.length > 0) {
        // tip：避免切换对话
        if (activeConversationId.value === filterConversationList[0].id) {
          emits('onConversationClick', filterConversationList[0]);
        }
      }
    };
    /** 删除聊天对话 */
    const deleteChatConversation = async conversation => {
      try {
        // 删除的二次确认
        await message.delConfirm(`是否确认删除对话 - ${conversation.title}?`);
        // 发起删除
        await ChatConversationApi.deleteChatConversationMy(conversation.id);
        message.success('对话已删除');
        // 刷新列表
        await getChatConversationList();
        // 回调
        emits('onConversationDelete', conversation);
      } catch {}
    };
    /** 清空对话 */
    const handleClearConversation = async () => {
      try {
        await message.confirm('确认后对话会全部清空，置顶的对话除外。');
        await ChatConversationApi.deleteChatConversationMyByUnpinned();
        ElMessage({
          message: '操作成功!',
          type: 'success'
        });
        // 清空 对话 和 对话内容
        activeConversationId.value = null;
        // 获取 对话列表
        await getChatConversationList();
        // 回调 方法
        emits('onConversationClear');
      } catch {}
    };
    /** 对话置顶 */
    const handleTop = async conversation => {
      // 更新对话置顶
      conversation.pinned = !conversation.pinned;
      await ChatConversationApi.updateChatConversationMy(conversation);
      // 刷新对话
      await getChatConversationList();
    };
    // ============ 角色仓库 ============
    /** 角色仓库抽屉 */
    const roleRepositoryOpen = ref(false); // 角色仓库是否打开
    const handleRoleRepository = async () => {
      roleRepositoryOpen.value = !roleRepositoryOpen.value;
    };
    /** 监听选中的对话 */
    const {
      activeId
    } = toRefs(props);
    watch(activeId, async (newValue, oldValue) => {
      activeConversationId.value = newValue;
    });
    // 定义 public 方法
    __expose({
      createConversation,
      refreshChatConversationList: getChatConversationList
    });
    /** 初始化 */
    onMounted(async () => {
      // 获取 对话列表
      await getChatConversationList();
      // 默认选中
      if (props.activeId) {
        activeConversationId.value = props.activeId;
      } else {
        // 首次默认选中第一个
        if (conversationList.value.length) {
          activeConversationId.value = conversationList.value[0].id;
          // 回调 onConversationClick
          await emits('onConversationClick', conversationList.value[0]);
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_drawer = _resolveComponent("el-drawer");
      const _component_el_aside = _resolveComponent("el-aside");
      return _openBlock(), _createBlock(_component_el_aside, {
        width: "260px",
        class: "conversation-container h-full"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
          class: "w-full btn-new-conversation",
          type: "primary",
          onClick: createConversation
        }, {
          default: _withCtx(() => [_createVNode(Icon, {
            icon: "ep:plus",
            class: "mr-5px"
          }), _cache[3] || (_cache[3] = _createTextVNode(" 新建对话 "))]),
          _: 1
        }), _createVNode(_component_el_input, {
          modelValue: searchName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchName.value = $event),
          size: "large",
          class: "mt-10px search-input",
          placeholder: "搜索历史记录",
          onKeyup: searchConversation
        }, {
          prefix: _withCtx(() => [_createVNode(Icon, {
            icon: "ep:search"
          })]),
          _: 1
        }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_2, [loading.value ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          description: ".",
          "v-loading": loading.value
        }, null, 8, ["v-loading"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(conversationMap.value), conversationKey => {
          return _openBlock(), _createElementBlock("div", {
            key: conversationKey
          }, [conversationMap.value[conversationKey].length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_text, {
            class: "mx-1",
            size: "small",
            tag: "b"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(conversationKey), 1)]),
            _: 2
          }, 1024)])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conversationMap.value[conversationKey], conversation => {
            return _openBlock(), _createElementBlock("div", {
              class: "conversation-item",
              key: conversation.id,
              onClick: $event => handleConversationClick(conversation.id),
              onMouseover: $event => hoverConversationId.value = conversation.id,
              onMouseout: _cache[1] || (_cache[1] = $event => hoverConversationId.value = null)
            }, [_createElementVNode("div", {
              class: _normalizeClass(conversation.id === activeConversationId.value ? 'conversation active' : 'conversation')
            }, [_createElementVNode("div", _hoisted_5, [_createVNode(Icon, {
              icon: "hugeicons:chat-bot",
              class: "mr-5px"
            }), _createElementVNode("span", _hoisted_6, _toDisplayString(conversation.title), 1)]), _withDirectives(_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
              class: "btn",
              link: "",
              onClick: _withModifiers($event => handleTop(conversation), ["stop"])
            }, {
              default: _withCtx(() => [!conversation.pinned ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                title: "置顶"
              }, {
                default: _withCtx(() => [_createVNode(_unref(Top))]),
                _: 1
              })) : _createCommentVNode("", true), conversation.pinned ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 1,
                title: "置顶"
              }, {
                default: _withCtx(() => [_createVNode(_unref(Bottom))]),
                _: 1
              })) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              class: "btn",
              link: "",
              onClick: _withModifiers($event => updateConversationTitle(conversation), ["stop"])
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, {
                title: "编辑"
              }, {
                default: _withCtx(() => [_createVNode(Icon, {
                  icon: "ep:edit"
                })]),
                _: 1
              })]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              class: "btn",
              link: "",
              onClick: _withModifiers($event => deleteChatConversation(conversation), ["stop"])
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, {
                title: "删除对话"
              }, {
                default: _withCtx(() => [_createVNode(Icon, {
                  icon: "ep:delete"
                })]),
                _: 1
              })]),
              _: 2
            }, 1032, ["onClick"])], 512), [[_vShow, hoverConversationId.value === conversation.id]])], 2)], 40, _hoisted_4);
          }), 128))]);
        }), 128)), _cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "h-160px w-100%"
        }, null, -1))])]), _createElementVNode("div", _hoisted_8, [false ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: handleRoleRepository
        }, [_createVNode(Icon, {
          icon: "ep:user"
        }), _createVNode(_component_el_text, {
          size: "small"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("角色仓库")])),
          _: 1
        })])) : _createCommentVNode("", true), _createElementVNode("div", {
          onClick: handleClearConversation
        }, [_createVNode(Icon, {
          icon: "ep:delete"
        }), _createVNode(_component_el_text, {
          size: "small"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("清空未置顶对话")])),
          _: 1
        })])]), _createVNode(_component_el_drawer, {
          modelValue: roleRepositoryOpen.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => roleRepositoryOpen.value = $event),
          title: "角色仓库",
          size: "754px"
        }, {
          default: _withCtx(() => [_createVNode(RoleRepository)]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      });
    };
  }
});